import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import { FormInput, FormPanelWithReadMode } from 'components/FormPanel';

const UPDATE_DEAL_SETUP_FEE_MUTATION = gql(`
    mutation UpdateDealSetupFee($dealId: ID!, $setupFeePercentage: Float!) {
      updateDealSetupFee(id: $dealId, setupFeePercentage: $setupFeePercentage) {
        id
        setupFeePercentage
    }
  }
`);

const UpdateSetupFee: FC<{ id: string; setupFeePercentage?: number | null }> = ({
  id,
  setupFeePercentage,
}) => {
  const [updateDealSetupFee, { loading, error }] = useMutation(UPDATE_DEAL_SETUP_FEE_MUTATION);

  return (
    <>
      <FormPanelWithReadMode
        loading={loading}
        error={error}
        onSubmit={data => {
          updateDealSetupFee({
            variables: {
              dealId: id,
              setupFeePercentage: data.setupFeePercentage,
            },
          });
        }}
      >
        <FormInput
          type="number"
          fieldName="setupFeePercentage"
          label="Update Setup Fee"
          defaultValue={setupFeePercentage}
        />
      </FormPanelWithReadMode>
    </>
  );
};

export default UpdateSetupFee;
